import { FormControl, OutlinedInput } from '@mui/material'
import React from 'react'
import CustomText from '../text/CustomText'

const FaultDescription = (props) => {
  const { name, value, onChange, maxLength, title } = props
  return (
    <FormControl fullWidth sx={{ mt: 1.5, mb: 1 }}>
      <CustomText sx={{ mb: 1 }}>{title}</CustomText>
      <OutlinedInput
        placeholder="Describe the issue with this asset"
        minRows={5}
        sx={{
          backgroundColor: '#FFFFFF',
          width: '100%',
          minHeight: 120,
          borderRadius: '10px',
        }}
        name={name}
        value={value}
        onChange={onChange}
        inputProps={{ maxLength: 250, ...maxLength }}
        multiline
      />
    </FormControl>
  )
}

export default FaultDescription
